export function Divider() {
  return <div class="w-4px h-40% rounded-lg bg#n-700" />;
}
